import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  },
});
